module.exports = __webpack_public_path__ + "static/media/paper-plane-white.70ab49f6.svg";